<template>
  <section>
    <b-dropdown
      aria-role="list"
      class="local-lm-filters"
      v-model="selectedOption"
      :disabled="flag"
      @active-change="storeOption"
    >
      <button
        class="button"
        type="button"
        slot="trigger"
      >
        <div class="local-lm-filters--placeholder">
          <template>
            <span
              v-if="!selectedOption"
              v-t="$t('StoreFilter.title')"
            />
            <span
              v-if="selectedOption"
              v-t="selectedOption"
            />
          </template>
          <b-icon
            icon="chevron-down"
          />
        </div>
      </button>
      <b-dropdown-item
        v-for="store in stores"
        :key="store.storeCode"
        :value="store.name"
      >
        {{ store.name | upperCase }}
      </b-dropdown-item>
    </b-dropdown>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'StoreFilter',
  computed: {
    ...mapGetters('filters', [
      'stores'
    ]),
    flag () {
      return this.$attrs.hasDisableStore
    }
  },
  mounted () {
    this.$store.dispatch('filters/getStores')
    this.$eventBus.$on('cleanFilters', () => {
      this.selectedOption = null
    })
  },
  data () {
    return {
      selectedOption: null
    }
  },
  methods: {
    storeOption () {
      const flag = !!(this.selectedOption) || false
      this.$store.dispatch('filters/setStoreSelected', this.selectedOption)
      this.$eventBus.$emit('orderStoreWrite', flag)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filters/StoreFilter.vue